import Form, {
  ButtonItem,
  ButtonOptions,
  Item,
  Label,
  RequiredRule,
} from "devextreme-react/form";
import LoadIndicator from "devextreme-react/load-indicator";
import notify from "../../lib/notify";
import React, { useCallback, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { firstLogin } from "../../api/auth";
import { useAuth } from "../../contexts/auth";
import "./FirstLoginForm.scss";

export const FirstLoginForm = ({ redirectLink = "/sign-in" }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { signInAuth, signIn } = useAuth();
  const { signOut } = useAuth();

  const email = location.state?.email || "";
  const password = location.state?.password || "";
  const companyId = location.state.companyId;

  const formData = useRef({ pesel: "" });
  const [loading, setLoading] = useState(false);

  const handleLogoutClick = async (e) => {
    e.preventDefault();
    await signOut();
    navigate(redirectLink);
  };

  const onSubmit = useCallback(
    async (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      setLoading(true);

      const { pesel } = formData.current;

      try {
        const resultFirst = await firstLogin(email, pesel, companyId);

        if (resultFirst.isOk) {
          navigate("/first-change-password", {
            state: {
              email,
              password,
              companyId,
            },
          });
        } else {
          notify(resultFirst.error || t("common.unknownErrorOccurred"), "error", 5000);
        }
      } catch (error) {
        notify(t("common.unknownErrorOccurred"), "error", 5000);
      } finally {
        setLoading(false);
      }
    },
    [email, password, companyId, signIn, signInAuth, navigate, t],
  );

  return (
    <form className="first-login-form" onSubmit={onSubmit}>
      <Form formData={formData.current} disabled={loading}>
        <Item
          render={() => (
            <div className="account-blocked-info">
              <p>
                {t(
                  "This is your first login. To log in, please provide your PESEL.",
                )}
              </p>
            </div>
          )}
        />
        <Item
          dataField="pesel"
          editorType="dxTextBox"
          editorOptions={{
            stylingMode: "filled",
            placeholder: t("PESEL"),
            mode: "text",
          }}
        >
          <RequiredRule message={t("Pesel is required")} />
          <Label text={t("PESEL")} />
        </Item>
        <ButtonItem>
          <ButtonOptions width="100%" type="default" useSubmitBehavior>
            <span className="dx-button-text">
              {loading ? (
                <LoadIndicator width="24px" height="24px" visible />
              ) : (
                t("submit")
              )}
            </span>
          </ButtonOptions>
        </ButtonItem>
      </Form>
      <div className="first-login-link">
        <a href={redirectLink} onClick={handleLogoutClick}>
          {t("Back to login")}
        </a>
      </div>
    </form>
  );
};
